import React from 'react';
import { Container, Box } from '@mui/material';
import { PageIndices } from '../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '../components/DashboardLayout';
import { AdminWorkoutsTab } from '@pages/admin/AdminLibraryPage/AdminWorkoutsTab';

export const AdminWorkoutsPage: React.FC = () => {
  return (
    <DashboardLayout>
      <Container maxWidth={false} data-i-doc={PageIndices.ADMIN_WORKOUTS}>
        <Box sx={{ width: '100%' }}>
          <AdminWorkoutsTab />
        </Box>
      </Container>
    </DashboardLayout>
  );
};
